import { getMetaEventId } from './metaEventId';

export const addFBEvent = (name: string) => {
  if (window.fbq === undefined) {
    console.warn('FB Pixel not loaded');

    return;
  }

  window.fbq('trackCustom', name, {}, { eventID: getMetaEventId() });
};
